export default "__VITE_ASSET__P1yIW9S7__"